<template>
  <div>
    <Header></Header>
    <div class="background" v-for="(list,index) in lists" :key="index">
      <div class="details_top">
        <div class="details-cont">
          <div class="left">
            <img class="portrait" :src="list.avatar" alt />
            <div>
              <p class="name">{{list.nickname}}</p>
              <p class="chenghu">{{list.the_title}}</p>
              <p class="jianjie">{{list.intro}}</p>
            </div>
          </div>
          <div class="right">
            <div class="kecheng">
              <p class="number">{{list.count}}</p>
              <p class="title">他的课程</p>
            </div>
            <div class="line"></div>
            <div class="bofang">
              <p class="number">{{list.playcount}}</p>
              <p class="title">他的播放</p>
            </div>
          </div>
        </div>
      </div>
      <div class="cont">
        <div class="cont-title">
          <ul>
            <li
              v-for="(tab,index) in tabs"
              :key="index"
              @click="toggle(index,tab.view)"
              :class="{active:active==index}"
            >{{tab.type}}</li>
          </ul>
          <div @click="shareToQQ" class="fenxiang">
            <img src="../../assets/img/w_fx.png" alt />
            <span>分享</span>
          </div>
        </div>
        <div v-show="currentView==`tab1`">
          <div class="cont1" v-html="list.content">{{list.content}}</div>
        </div>
        <div v-show="currentView==`tab2`">
          <div class="Course">
            <div class="details">
              <div
                class="list"
                @click="godetails(t_list.id)"
                v-for="(t_list,index) in t_lists"
                :key="index"
              >
                <img :src="t_list.image" alt />
                <p class="title">{{t_list.name}}</p>
                <div class="jiage">
                  <img class="touxiang" :src="t_list.teacher_image" alt />
                  <p class="name">{{t_list.teacher_name}}</p>
                  <p class="price" v-if="t_list.members_free==1">VIP免费</p>
                  <p
                    class="price"
                    v-if="t_list.price!=0.00&&t_list.members_free==0"
                  >¥{{t_list.price}}</p>
                  <p class="price" v-if="t_list.price==0.00">免费</p>
                </div>
                <div class="solid"></div>
                <div class="list-footer">
                  <div class="left">
                    <img src="../../assets/img/se.png" alt />
                    <span>{{t_list.sales}}</span>
                  </div>
                  <div class="center"></div>
                  <div class="right">
                    <img src="../../assets/img/pl.png" alt />
                    <span>{{t_list.number}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin:0 auto;width:800px;text-align:center;">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout=" prev, pager, next"
              :total="totalNum"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
export default {
  name: "",
  data() {
    return {
      active: 0,
      currentView: "tab1",
      tabs: [
        {
          type: "讲师介绍",
          view: "tab1",
        },
        {
          type: "课程介绍",
          view: "tab2",
        },
      ],
      id: "",
      lists: [],
      t_lists: [],
      tableData: [], //数据
      currentPage: 1, //默认显示第一页
      pageSize: 8, //默认每页显示条
      totalNum: 0, //总页数
    };
  },
  created() {
    var good = this.$route.query.id;
    this.id = good;
  },
  methods: {
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "知会教育",
        desc: "知会教育pc端QQ分享",
        share_url: window.location.href,
      };
      location.replace(
        "https://connect.qq.com/widget/shareqq/index.html?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc
      );
    },
    // tab切换
    toggle(i, v) {
      this.active = i;
      this.currentView = v;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val; //动态改变
      this.teacher_course_list();
    },
    // 科研团队
    async teacher_data() {
      await this.$service.home
        .teacher_data({ id: this.id })
        .then((res) => {
          console.log(res.data);
          if (res.data.code == 200) {
            this.lists.push(res.data.content);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 老师课程列表
    async teacher_course_list() {
      await this.$service.home
        .teacher_course_list({
          id: this.id,
          page: this.currentPage,
          page_count: this.pageSize,
        })
        .then((res) => {
          // console.log(res.data.content.count);
          if (res.data.code == 200) {
            this.t_lists = res.data.content.list;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum = totalNum;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转课程详情
    godetails(id) {
      this.$router.push({
        path: "details",
        query: {
          id: id,
        },
      });
    },
  },
  components: {
    Header,
    Footer,
  },
  mounted() {
    this.teacher_data();
    this.teacher_course_list();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.active {
  color: #1775ef;
}
.details_top {
  background-image: url("../../assets/img/bgg.png");
  margin-bottom: 20px;
}
.details_top .details-cont {
  width: 1200px;
  height: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.details_top .details-cont .left {
  width: 492px;
  display: flex;
}
.details_top .details-cont .left .portrait {
  width: 95px;
  height: 120px;
  border-radius: 6px;
  border: 2px solid rgba(255, 255, 255, 1);
  margin-right: 12px;
}
.details_top .details-cont .left div p.name {
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 28px;
  margin-bottom: 6px;
}
.details_top .details-cont .left div p.chenghu {
  width: 90px;
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  margin-bottom: 6px;
}
.details_top .details-cont .left div p.jianjie {
  width: 385px;
  height: 60px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}
.details_top .details-cont .right {
  width: 300px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-align: center;
}
.details_top .details-cont .right .kecheng .number,
.details_top .details-cont .right .bofang .number {
  font-size: 36px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  letter-spacing: 2px;
}
.details_top .details-cont .right .line {
  width: 1px;
  height: 48px;
  background: rgba(255, 255, 255, 1);
}
.details_top .details-cont .right .kecheng .title,
.details_top .details-cont .right .bofang .title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  letter-spacing: 1px;
}
.cont {
  width: 1200px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  margin: 0 auto;
  margin-bottom: 20px;
}
.cont .cont-title {
  height: 62px;
  border-bottom: 1px solid #ededed;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cont .cont-title ul li {
  width: 100px;
  display: inline-flex;
  align-items: center;
  justify-content: space-around;
}
.cont .cont-title .fenxiang {
  margin-right: 18px;
}
.cont .cont-title .fenxiang img {
  margin-right: 2px;
}
.cont1 {
  width: 580px;
  min-height: 500px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 26px;
  margin-left: 26px;
  margin-top: 13px;
}

/* 详情 */
.Course .details {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 95%;
  margin: 0 auto;
  margin-top: 16px;
}
.Course .list {
  margin-bottom: 48px;
  width: 270px;
  height: 350px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  border: 1px solid rgba(234, 234, 234, 1);
}
.Course .list img {
  width: 270px;
  height: 180px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.Course .list .title {
  text-align: left;
  width: 245px;
  height: 50px;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  letter-spacing: 1px;
  margin: 10px 0 10px 13px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /*控制可显示几行文本*/
}
.Course .list .jiage {
  display: flex;
  text-align: center;
  margin: 0 8px 20px 13px;
  height: 30px;
  display: flex;
  align-items: center;
}
.Course .list .jiage .touxiang {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.Course .list .jiage p.name {
  min-width: 61px;
  height: 20px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 4px;
  margin-right: 60px;
}
.Course .list .jiage p.price {
  /* width: 59px; */
  height: 16px;
  font-size: 18px;
  color: rgba(255, 67, 67, 1);
  line-height: 1px;
}
.Course .list .solid {
  width: 270px;
  height: 1px;
  background: rgba(234, 234, 234, 1);
}
.Course .list .list-footer {
  display: flex;
  justify-content: space-around;
}
.Course .list .list-footer .left,
.Course .list .list-footer .right {
  width: 50px;
  display: flex;
  justify-content: space-around;
  line-height: 35px;
}
.Course .list .list-footer .left img,
.Course .list .list-footer .right img {
  width: 17px;
  height: 12px;
  margin-top: 12px;
}
.Course .list .list-footer .center {
  width: 1px;
  height: 20px;
  background: rgba(234, 234, 234, 1);
  margin-top: 7px;
}
.Course .list .list-footer .right span,
.Course .list .list-footer .left span {
  width: 21px;
  height: 16px;
  font-size: 12px;
  color: rgba(136, 136, 136, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/jytd/topic_details.vue